import { Common, color } from '@stockbit/ui';
import styled, { css } from 'styled-components';

const { Button } = Common;

export const FooterWrapper = styled.div`
  border-top: 1px solid ${color.downgray};
  padding: 10px 8px;
  width: 100%;
  background: ${color.light};
`;

export const ButtonApply = styled(Button).attrs({
  block: true,
  type: 'primary',
})`
  border-radius: 4px;
  font-weight: 700;
  padding: 6px;
  font-size: 12px;
  line-height: 16px;

  ${({ type }) => type === 'primary' && css`
    :disabled {
      color: ${color.light};
      background: ${color.hummingBird} !important;
    }

    :hover:disabled {
      color: ${color.light};
    }
  `}
`;

interface SelectedSymbolWrapperProps {
  isDisabled: boolean;
}

export const SelectedSymbolWrapper = styled.div <SelectedSymbolWrapperProps>`
  display: flex;
  padding-top: 8px;
  flex-flow: wrap;
  justify-content: left;
  align-items: flex-start;
  overflow: auto;

  ${({ isDisabled }) => isDisabled && css`
    opacity: 0.6;
  `}
`;

export const DropdownContentWrapper = styled.div`
  height: 451px;
  overflow: auto;
`;

export const StockCount = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${color.hummingBird};
  display: flex;
  align-items: center;
  justify-content: center;
`;
